import { BpCheckbox } from '../../../../shared/components/forms/checkbox/BpCheckbox'
import React, { useEffect, useState } from 'react'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { setLiveSearchType } from '../../model/liveSearchSlice'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import styles from './LiveSearchTypes.module.scss'

export const LiveSearchTypes = ({
  isLoading,
  disable,
}: {
  isLoading: boolean
  disable: boolean
}) => {
  const { t } = useTranslation()
  const [state, setState] = useState({ paid: false, organic: false })
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(
      setLiveSearchType(
        state.paid && state.organic
          ? 'all'
          : state.paid
            ? 'paid'
            : state.organic
              ? 'organic'
              : 'all',
      ),
    )
  }, [state])

  return (
    <div className={clsx(styles.root)}>
      {t('pages.liveSearch.showResults')}
      <div className={clsx(styles.checkboxes)}>
        <BpCheckbox
          disabled={isLoading || disable}
          label={t('pages.liveSearch.paid')}
          onChange={(e) => setState({ ...state, paid: e.target.checked })}
        />
        <BpCheckbox
          disabled={isLoading || disable}
          label={t('pages.liveSearch.organic')}
          onChange={(e) => setState({ ...state, organic: e.target.checked })}
        />
      </div>
    </div>
  )
}
